import { APIPost, APIDelete, APIUrl, AdminType, StatusCode } from "api/protocols";

interface IPricingSheetProductRes {
  data: any;
  status: StatusCode;
}
interface IDeletePricingSheetProduct {
  pricing_sheet_id: number;
  variant_id: Array<number>;
}

interface IPostPricingSheetProduct {
  pricing_sheet_id: number;
  variant_ids: Array<number>;
}

interface ICopyPricingSheetProducts {
  pricing_sheet_ids: Array<number>;
  variant_ids: Array<number>;
}
export async function PostPricingSheetProduct(
  params: IPostPricingSheetProduct,
  useGlobalLoader: boolean,
): Promise<IPricingSheetProductRes> {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/tee-sheet/pricing-sheet/product"), params, useGlobalLoader);
}

export async function DeletePricingSheetProduct(
  params: IDeletePricingSheetProduct,
  useGlobalLoader: boolean,
): Promise<IPricingSheetProductRes> {
  return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/tee-sheet/pricing-sheet/product"), params, useGlobalLoader);
}

export async function CopyPricingSheetProducts(
  params: ICopyPricingSheetProducts,
  useGlobalLoader: boolean,
): Promise<IPricingSheetProductRes> {
  return await APIPost(
    APIUrl(AdminType.FacilityAdmin, "/tee-sheet/pricing-sheet/product/copy"),
    params,
    useGlobalLoader,
  );
}
